import { createStandardAction, createAsyncAction } from 'typesafe-actions'
import {
  GetDataListReq,
  GetDataListResp,
  CommonResp,
  UpdateDataReq,
} from './types'

export const getDataListAction = createAsyncAction(
  'adminpj/primavera/FETCH_LIST_REQUEST',
  'adminpj/primavera/FETCH_LIST_SUCCESS',
  'adminpj/primavera/FETCH_LIST_FAILURE'
)<GetDataListReq, GetDataListResp, any>()

export const updateDataAction = createAsyncAction(
  'adminpj/primavera/UPDATE_DATA_REQ',
  'adminpj/primavera/UPDATE_DATA_RESP',
  'adminpj/primavera/UPDATE_DATA_FAIL'
)<UpdateDataReq, CommonResp, any>()

export const resetEvent = createStandardAction('admin/user/RESET_EVENT_ACTION')<
  void
>()
